{
  "title": "How to View Submissions Assigned to Me",
  "description": "See every submission the organizer assigned to you and its current scoring progress, in your judge workspace.",
  "headings": [
    "What You'll Accomplish",
    "Applies To",
    "Before You Start",
    "Steps",
    "What You'll See",
    "FAQ"
  ],
  "summary": "When you're done, you can see every submission assigned to you by the organizer, its current scoring progress, and each submission's anonymous code.",
  "roleNote": "Judge",
  "prerequisites": ["You've accepted your judge invitation and are signed in"],
  "pathLabel": "Judge Workspace → My Assignment List",
  "steps": [
    {
      "title": "1. Open the judge workspace",
      "description": "After signing in, go to \"Judge Workspace\" — it lists a card for every submission assigned to you."
    },
    {
      "title": "2. Filter by round",
      "description": "If the competition has multiple rounds, switch rounds to see only that round's assignments; each card shows its round and rubric version."
    },
    {
      "title": "3. Filter by scoring progress",
      "description": "Switch between \"All / Pending / Draft / Submitted\" to quickly find what's still outstanding. The top of the list shows the judging deadline with the time left (marked \"Overdue\" in red once past) and an overall progress bar, with unfinished work listed first. The first time you open a competition you must read and tick \"Judging terms and confidentiality\"."
    },
    {
      "title": "4. Open a single submission",
      "description": "Click a card to open its scoring page — the submission is shown by its anonymous code (not the team's real name), along with its rubric and uploaded files. If the team filled in a URL field (such as a video URL) it is listed under \"Submitted links\", and YouTube or Vimeo addresses can be played in the \"Video\" tab."
    }
  ],
  "afterward": [
    "The list reflects each submission's current scoring status in real time (not started / draft / submitted)",
    "A submission you've recused yourself from stays in the list, but is marked \"Recused\" and cannot be scored",
    "Submissions are shown by anonymous code, never by the participating team's actual name"
  ],
  "nextSteps": "Once you've found the submission to score, see \"How to Score and Formally Submit\" to complete it.",
  "faq": [
    {
      "q": "Why does my assignment list show an anonymous code instead of a team name?",
      "a": "This is intentional, so judging is not influenced by which team a submission belongs to; the anonymous code is generated by the system from the submission's id."
    },
    {
      "q": "Why does one of my cards show \"Recused\" and can't be clicked through to scoring?",
      "a": "This means a conflict of interest has been declared for that submission (either by you or by the organizer). The card stays in your list so both you and the organizer can see the assignment still exists, but scoring and file download are both rejected by the server."
    },
    {
      "q": "A submission I expected to be assigned to me isn't showing up — what should I check?",
      "a": "Contact that competition's organizer to confirm the assignment was actually created, the round is correct, or whether it was automatically skipped for being a duplicate assignment or a conflict of interest."
    }
  ]
}
